// src/components/mediaConversion/MediaConversionPanel/stages.tsx
import React from "react";
import type { StageStatus } from "@/types/mediaConversion/mediaConversionTypes";
import {
  Clock,
  Loader2,
  Film,
  Sparkles,
  CheckCircle2,
  XCircle,
  Ban,
  Dot,
} from "lucide-react";

export function getStageIcon(
  stageKey: string,
  status: StageStatus
): React.ReactNode {
  const key = (stageKey || "").toLowerCase();

  const baseProps = { size: 16 } as const;

  // Status-first icons.
  if (status === "done") return React.createElement(CheckCircle2, baseProps);
  if (status === "error") return React.createElement(XCircle, baseProps);

  // Common weighted timeline keys.
  if (key === "prepare" || key === "preparing")
    return React.createElement(Loader2, {
      ...baseProps,
      className: "mcSpin",
    });

  if (key === "queued") return React.createElement(Clock, baseProps);

  if (key === "processing")
    return React.createElement(Loader2, {
      ...baseProps,
      className: "mcSpin",
    });

  if (key === "source")
    return React.createElement(Film, baseProps);

  if (key === "finalize" || key === "finalizing")
    return React.createElement(Sparkles, baseProps);

  // Encodes like 1080p/720p/480p.
  if (/\b(1080p|720p|480p)\b/.test(key))
    return React.createElement(Film, baseProps);

  if (key === "failed") return React.createElement(XCircle, baseProps);
  if (key === "canceled") return React.createElement(Ban, baseProps);

  return React.createElement(Dot, baseProps);
}